import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { toRefs } from 'vue';
import { IonList } from '@ionic/vue';

import { ICourse } from '@/support/models/course.interface';

import CourseCard from '@/components/Course/CourseCard.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CourseList',
  props: {
    courses: null
  },
  setup(__props: any) {

const props = __props as {
  courses: ICourse[];
}



const { courses } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonList), { class: "ion-padding" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(courses), (course, index) => {
        return (_openBlock(), _createBlock(CourseCard, {
          key: index,
          "router-link": `/course/${course.id}`,
          course: course
        }, null, 8, ["router-link", "course"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})